(function(){
  'use strict';

  eclipseApp.controller('WarningModalCtrl', ['$scope', '$modalInstance', 'data', function($scope, $modalInstance, data){

    data.title = data.title || 'Title';
    data.message = data.message || 'Message';
    data.okLabel = data.okLabel || 'Ok';

    $scope.title = data.title;
    $scope.message = data.message;
    $scope.okButtonLabel = data.okLabel;

    $scope.ok = function(){
      $modalInstance.close();
    };
    $scope.cancel = function(){
      $modalInstance.close();
    };
  }]);
})();
